export const GOOGLE_AD_ID = "ca-pub-2560881265443445";

export enum GoogleAdType {
  WIDE = "WIDE",
}

export const googleAdTypeToSlotMap: Record<GoogleAdType, string> = {
  [GoogleAdType.WIDE]: "7492191910",
};
